import React from 'react';
import './Services.css'; // overview 스타일 포함

function PhotoBoothIOBox() {
    const vmpb1Items = [
      { title: '카메라 전원 리셋', value: '카메라 오류를 원격에서 안전하게 복구시키는 기능' },
      { title: '지폐/코인기 제어', value: '지불 확인, 투입 금지 제어, 금액 카운팅 및 전원 리셋 기능' },
      { title: '호퍼 제어', value: '서비스 상품 배출 기능' },
      { title: '일반 조명', value: 'LED 상시 점등 조명' },
      { title: '제어 조명', value: 'ON AIR 상태 표시용 LED조명' },
      { title: '출력 상태 RGB 조명', value: '출력중 / 출력완료 / 알람 상태 표시' },
      { title: '릴리즈 입력', value: '카메라 릴리즈 신호 입력 지원' },
      { title: '릴리즈 출력', value: '카메라 셔터/반셔터 신호 출력 지원' },
      { title: '서비스 버튼', value: '전원 리셋 및 서비스 버튼 제공' }
    ];
    const vmpb2Items = [
      { title: '통신', value: 'RS232 시리얼 통신' },
      { title: '전원 입력', value: 'AC 100-240V, 50/60Hz' },
      { title: '상태 조명', value: '12V LED, 12V RGB LED' },
      { title: '인증', value: 'KC 인증, RoHS 대응' },
      { title: '적용 환경', value: '내수 및 수출 겸용 (광범위한 전원 조건 대응)' }
    ];

    return (
      <div className="overview-container">
        <div className="section-title-box">포토부스 IO 박스 [Photobooth I/O Controller]</div>
        <div className="services-header">
          <div className="services-image">
            <img src="/images/PhotoboothIO_M3.png" alt="포토부스 IO 박스" />
          </div>
          <div className="services-text">
            <p>
            <strong>포토부스 IO 박스는 무인 포토부스 시스템의 핵심 장치로, 카메라와 결제 장비, 조명, 인쇄 상태 등을 통합적으로 제어할 수 있는 통신 기반 제어 장치입니다.</strong>
            </p>
            <p>
            무인으로 운영되는 포토부스 환경에서는 카메라 오류나 결제 장치 오작동 등으로 인해 장비가 멈추는 경우가 종종 발생합니다. 
            이 IO 박스는 그러한 문제 상황을 원격으로 실시간 대응할 수 있게 해주며, 특히 <strong>전원 리셋 기능</strong>은 현장 방문 없이도 오류 장비를 안전하게 재부팅할 수 있도록 해줍니다.
            </p>
            <p>
            또한 <strong>지불 장치 연동</strong>, <strong>호퍼 연동</strong>, <strong>사용 중 표시등(ON AIR)</strong>, <strong>출력 상태 RGB 조명</strong> 등을 통해 사용자와 운영자 모두에게 직관적이고 효율적인 운영 환경을 제공합니다.
            </p>
            <p>
            KC 인증, RoHS 대응, AC 100–240V의 폭넓은 전원 사양을 지원하여 국내외 다양한 포토부스 기종에 동일하게 적용 가능합니다.
            </p>
            <p>
            [Photobooth IO Interface, Photobooth IO Controller, Photobooth IO Board, Photobooth Controller, Photobooth Control Box]
            </p>
          </div>
        </div>
      {/* 주요 기능 및 사양 */}
      <div className="overview-section">
        <h3>주요 기능</h3>
        <div className="overview-table">
          {vmpb1Items.map((item, index) => (
            <div key={index} className="overview-row">
                <div className="overview-title">{item.title}</div>
                <div className="overview-value">{item.value}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="overview-section">
        <h3>기술 사양</h3>
        <div className="overview-table">
          {vmpb2Items.map((item, index) => (
            <div key={index} className="overview-row">
                <div className="overview-title">{item.title}</div>
                <div className="overview-value">{item.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PhotoBoothIOBox;
